<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.5 13.5">
    <g id="layout" transform="translate(0.684 0.684)">
      <rect
        id="Rectangle_77"
        data-name="Rectangle 77"
        width="12"
        height="12"
        rx="2"
        transform="translate(0.066 0.066)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_282"
        data-name="Line 282"
        x2="12"
        transform="translate(0.066 5.066)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_283"
        data-name="Line 283"
        y2="7"
        transform="translate(7.066 5.066)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
